<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item active" aria-current="page">{{ translations('navbar.various_tallies') }}</li>
      </ol>
      <v-tabs v-model="tab" fixed-tabs>
        <v-tab v-for="itemTab in translatedTabs" :key="itemTab.id" class="custom-tab">
         {{ itemTab.tab }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <keep-alive>
          <component :is="tab === 0 ? 'DashboardChart' : 'ArchiveSummarySales'">
          </component>
        </keep-alive>
      </v-tabs-items>
    </nav>
  </div>
</template>

<script>
import DashboardChart from '@/components/dashboard/DashboardChart.vue'
import ArchiveSummarySales from '@/components/dashboard/DashboardDetail/ArchiveSummarySales.vue'
import { mapState } from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    DashboardChart,
    ArchiveSummarySales
  },
  watch: {
    tab (val) {
      let params = this.$session.get('DashboardParams') || {}
      params.tab = val
      this.$session.set('DashboardParams', params)
    },
    currentLanguage: {
      handler (newValue, oldValue) {
        console.log('Current language changed to:', newValue)
      },
      immediate: true
    }
  },
  data () {
    return {
      tab: 0
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    translatedTabs () {
      const tabs = [
        { tab: '売上粗利分析指標', id: 0 },
        { tab: '売上粗利実績明細', id: 1 }
      ]
      return tabs.map(tab => {
        return {
          ...tab,
          tab: this.translations(`tabs.${tab.tab}`)
        }
      })
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    }
  }
}
</script>

<style scoped>
.main-content-wrapper {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.main-content-box {
  background-color: #fff;
}

.custom-tab {
  font-size: 12px;
}
</style>
